var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.8 53.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0610_\u5F8C\u53F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.92,
    cy: 17.46,
    r: 4.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2,32.84A12.83,12.83,0,0,0,50,29.41V8.18a8.36,8.36,0,0,0-2.38-5.8A8.1,8.1,0,0,0,41.83,0H8.18a8.36,8.36,0,0,0-5.8,2.38A8.1,8.1,0,0,0,0,8.18V42.82a8.36,8.36,0,0,0,2.38,5.8A8.1,8.1,0,0,0,8.18,51H40.73A12.27,12.27,0,0,0,57.2,32.84ZM3.07,8.18A5.16,5.16,0,0,1,8.18,3.07H41.83a5.14,5.14,0,0,1,5.1,5.11v18.1l-8.58-8.53a1.56,1.56,0,0,0-2.21,0l-12.93,13-8.76-8.82a1.56,1.56,0,0,0-2.21,0L3.07,31.21Zm5,39.8v-.06a5.06,5.06,0,0,1-3.59-1.51,5.25,5.25,0,0,1-1.46-3.59V35.56L13.4,25.24,22.16,34a1.62,1.62,0,0,0,2.21,0L37.3,21l8.47,8.53-.52.17a5.3,5.3,0,0,0-.75.24c-.23,0-.47.17-.7.23a1.65,1.65,0,0,0-.46.23,5.21,5.21,0,0,0-.58.29l-.87.52-.47.29c-.11.06-.17.12-.29.18a7,7,0,0,0-1.39,1.21,12.31,12.31,0,0,0-3.6,8.71,13,13,0,0,0,.29,2.55c.06.23.12.41.18.64.17.58.35,1.16.58,1.74v.06A10.88,10.88,0,0,0,37.94,48ZM54.94,48a9.16,9.16,0,0,1-12.82.11c-.23-.23-.47-.52-.7-.75s-.35-.41-.52-.58a5.36,5.36,0,0,1-.58-1c-.12-.23-.23-.4-.35-.64a5.37,5.37,0,0,1-.29-1c-.06-.23-.17-.52-.23-.76A9.41,9.41,0,0,1,42,35.1a9.06,9.06,0,0,1,6.49-2.67,9.28,9.28,0,0,1,6.5,2.67,9,9,0,0,1,2.67,6.5A9.32,9.32,0,0,1,54.94,48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.49,40H50V36.43a1.57,1.57,0,0,0-3.13,0V40H43.28a1.57,1.57,0,0,0,0,3.14h3.54v3.53a1.57,1.57,0,1,0,3.13,0V43.11h3.54a1.57,1.57,0,0,0,0-3.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/addImage.289db277759d7f1b4ec57716d6708c92.svg";
export { ForwardRef as ReactComponent };